import CloseSVG from '@public/icons/close-btn.svg';
import { useEffect } from 'react';
import { useSetOpenedPopupsState } from '@/shared/atoms/opened-popups';
import Popup from '@/shared/components/shared/Popup';
import { useSessionStorage } from '@/shared/hooks/use-session-storage';
import { tp } from '@/shared/lib/typograf';

export const INFORMATION_POPUP = 'information-popup';

export type InformationPopupProps = {
    title: string;
    description?: string;
    subtitle?: string;
    timeDuration?: number;
};

interface Props extends React.HTMLAttributes<HTMLElement> {
    InformationProps: InformationPopupProps;
}

function InformationPopup({ InformationProps }: Props) {
    const TIME_DURATION = InformationProps?.timeDuration ? InformationProps.timeDuration * 1000 : 14000;

    const { closePopup, openPopup } = useSetOpenedPopupsState();

    const [popupShownInSession, setPopupShownInSession] = useSessionStorage<boolean>('InformationPopupShow', false);

    useEffect(() => {
        if (!InformationProps.title) return;
        if (popupShownInSession) return;

        const timeoutId = setTimeout(() => {
            openPopup(INFORMATION_POPUP);
        }, TIME_DURATION);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [InformationProps.title, popupShownInSession, openPopup, setPopupShownInSession]);

    const handleClosePopup = () => {
        closePopup(INFORMATION_POPUP);
        setPopupShownInSession(true);
    };

    return (
        InformationProps.title && (
            <Popup
                name={INFORMATION_POPUP}
                data-popup-preset="default"
                className="information-popup information-popup"
                overlay={true}
            >
                <div className="information-popup__container">
                    <div className="information-popup__left">
                        <h2
                            className="information-popup-title text-xl"
                            dangerouslySetInnerHTML={{
                                __html: tp(InformationProps.title),
                            }}
                        ></h2>
                    </div>
                    <div className="information-popup__right">
                        <div
                            className="information-popup__subtitle text-s"
                            dangerouslySetInnerHTML={{
                                __html: tp(InformationProps.subtitle || ''),
                            }}
                        ></div>
                        <div
                            className="information-popup__description text-s"
                            dangerouslySetInnerHTML={{
                                __html: tp(InformationProps.description || ''),
                            }}
                        ></div>
                    </div>
                    <button
                        aria-label="Закрыть"
                        className="menu-popup-close-btn"
                        onClick={() => {
                            handleClosePopup();
                        }}
                    >
                        <CloseSVG />
                    </button>
                </div>
            </Popup>
        )
    );
}

export default InformationPopup;
